var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-overlay',{attrs:{"show":_vm.isLoading,"spinner-type":"grow","spinner-variant":_vm.variant,"label":"Spinning","rounded":"sm","variant":"light","spinner-small":_vm.small,"no-fade":""}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }